function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Divider from "@mui/material/Divider";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Alert from "@mui/material/Alert";
import { useThemeContext } from "../../../../contexts/ThemeContext";
import Dialog from "../../../../components/mui/material/Dialog";
var tKey = "features.Chat.Groups.OptionsMenu";
function OptionsMenu(props) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useThemeContext = useThemeContext(),
    theme = _useThemeContext.theme,
    toggleTheme = _useThemeContext.toggleTheme;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    dialogOpen = _useState2[0],
    setDialogOpen = _useState2[1];
  function toggleDialogOpen() {
    setDialogOpen(!dialogOpen);
  }
  var forwardProps = function (_ref) {
    var rest = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
    return rest;
  }(props);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Menu, _extends({
    id: "menu-appbar",
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "right"
    },
    keepMounted: true,
    transformOrigin: {
      vertical: "top",
      horizontal: "right"
    }
  }, forwardProps), /*#__PURE__*/React.createElement(MenuItem, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Switch, {
      checked: theme === "dark",
      onChange: toggleTheme,
      color: "primary"
    }),
    label: t("".concat(tKey, ".darkTheme"))
  })), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(MenuItem, {
    onClick: toggleDialogOpen
  }, t("".concat(tKey, ".about")))), /*#__PURE__*/React.createElement(Dialog, {
    open: dialogOpen,
    onClose: toggleDialogOpen,
    onKeyDown: function onKeyDown(e) {
      return e.stopPropagation();
    },
    "aria-labelledby": "alert-dialog-title",
    "aria-describedby": "alert-dialog-description",
    PaperProps: {
      elevation: 0,
      sx: {
        overflow: "visible",
        filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))"
      }
    },
    sx: {
      backdropFilter: "blur(5px) sepia(5%)"
    }
  }, /*#__PURE__*/React.createElement(DialogTitle, null, "\xA1Descubre la nueva funcionalidad de Front Chat con IA!"), /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement(DialogContentText, null, /*#__PURE__*/React.createElement("p", null, "Ahora puedes interactuar con usuarios virtuales impulsados por inteligencia artificial, como si estuvieras hablando con figuras de renombre, como Warren Buffet. Haz preguntas, recibe consejos y explora ideas como nunca antes con nuestra nueva tecnolog\xEDa de chat avanzada."), /*#__PURE__*/React.createElement("p", null, "Esta funcionalidad te permite acceder a respuestas personalizadas e interacciones realistas, llevando la experiencia de inversi\xF3n al siguiente nivel."), /*#__PURE__*/React.createElement(Alert, {
    severity: "info",
    style: {
      alignItems: "center",
      fontSize: 13
    }
  }, /*#__PURE__*/React.createElement("p", null, "La informaci\xF3n utilizada en este chat incluye saldos y datos del usuario, pero estos no son identificables y se procesan de manera an\xF3nima para proteger tu privacidad."), /*#__PURE__*/React.createElement("p", null, "La funcionalidad est\xE1 en fase beta, por lo que podr\xEDa haber cambios y mejoras."), /*#__PURE__*/React.createElement("p", null, "No compartas informaci\xF3n sensible o personal durante las interacciones."), /*#__PURE__*/React.createElement("p", null, "Los mensajes pueden ser eliminados permanentemente en el futuro."))))));
}
export default OptionsMenu;